"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeedBar = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Slider_1 = __importDefault(require("@material-ui/core/Slider"));
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../lib/utils");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            display: 'flex',
            flexDirection: 'row',
            marginRight: theme.spacing(4),
            alignItems: 'center',
        },
        speedButton: {
            fontSize: 10,
            padding: 2,
            minWidth: theme.spacing(3),
            marginRight: theme.spacing(1),
        },
    });
});
var SpeedSlider = function (props) { return styles_1.withStyles(function (theme) { return (__assign({}, utils_1.getSliderSizes(props.thickness, ({
    thumb: {
        color: theme.palette[props.color || 'primary'].main,
        display: props.thumb === false ? 'none' : 'block',
    },
    rail: {
        color: theme.palette[props.color || 'primary'].main,
    },
    track: {
        color: theme.palette[props.color || 'primary'].main,
    },
})))); })(Slider_1.default); };
var SpeedBar = function (props) {
    var defaultSpeed = 50;
    var _a = react_1.useState(defaultSpeed), speedBar = _a[0], setSpeedBar = _a[1];
    var classes = useStyles();
    var PlayerSpeedBar = SpeedSlider(props);
    var toSpeedValue = function (speed) { return speed * 0.018 + 0.1; };
    var onSpeedChange = function (_, newValue) {
        var speed = newValue;
        setSpeedBar(speed);
        props.player.playbackRate = toSpeedValue(speed);
    };
    var onNormalSpeedClick = function () {
        setSpeedBar(defaultSpeed);
        props.player.playbackRate = toSpeedValue(defaultSpeed);
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(Button_1.default, { color: props.color || 'primary', variant: "contained", "aria-label": "Normal speed", size: "small", className: classes.speedButton, onClick: onNormalSpeedClick }, "1x"),
        react_1.default.createElement(PlayerSpeedBar, { defaultValue: defaultSpeed, value: speedBar, onChange: onSpeedChange })));
};
exports.SpeedBar = SpeedBar;
//# sourceMappingURL=SpeedBar.js.map